module.exports = __webpack_public_path__ + "img/main_point_img02.6cee01b7.svg";